module.exports = __webpack_public_path__ + "img/telephone-1_icon-icons.com_65082.5fa4a13f.png";